import {
  ChangeDetectionStrategy,
  Component,
  NgZone,
  NO_ERRORS_SCHEMA,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageBusService } from '@xdig/ng-microkernel/micro-frontend';

@Component({
  selector: 'shell-download-app-qr',
  templateUrl: './download-app-qr-modal.component.html',
  styleUrls: ['./download-app-qr-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class DownloadAppQrModalComponent {
  urlToDownload: string;

  constructor(
    public dialogRef: MatDialog,
    public ngZone: NgZone,
    public messageBus: MessageBusService,
  ) {
    this.urlToDownload = this.messageBus.getValue('shell', 'urlToObtailApp');
  }

  closeModal() {
    this.ngZone.run(() => {
      this.dialogRef.closeAll();
    });
  }
}
